module.exports = __webpack_public_path__ + "img/sixpackcarrier95.f6ab9a54.jpg";